import { Grid, Typography } from 'material-ui'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Footer } from '../components/Footer'
import { ProjectSelectorCard, ProjectSelectorTitle } from '../components/ProjectSelectorCard'
import { SpreadBody } from '../components/SpreadBody'
import { MainBlurb } from './MainBlurb'
import { TitleSpread, TitleSpreadBody, TitleSpreadContent } from './TitleSpread'

interface Props {}

interface State {

}

export class RandomLengthsStory extends React.Component<RouteComponentProps<Props, {}>, State> {
    componentDidMount() {
        window.scroll(0, 0)
    }

    XprizeTitleSpread = () => {
        return (
            <TitleSpread
                img='/img/rl-story/rl-green-photo-bg.png'
                color='#36426a'
                goBack={() => this.props.router.push('/')}
            >
                <TitleSpreadBody>
                    <TitleSpreadContent
                        extraLargeTitle
                        sub='Partner Story'
                        title='Random Lengths'
                    >
                        The most widely circulated and respected source of information for the wood products industry
                        asked Twenty Ideas to help them reconsider how they manage their subscriber base. This
                        collaboration led to the development of their subscription managment portal.
                    </TitleSpreadContent>
                </TitleSpreadBody>
            </TitleSpread>
        )
    }

    Strategy = () => {
        return (
            <SpreadBody>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Technology Strategy'>
                            We began our collaboration with Random Lengths helping to identify the biggest
                            technology-enabling opportunities. After identifying and prioritizing, we explored the
                            existing Random Lengths infrastructure and created a stepwise plan to get them where they
                            wanted to go.
                        </MainBlurb>
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    AdminPortal = () => {
        return (
            <SpreadBody greyBg>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Customer and Administrative Portal'>
                            We designed and developed the initial interface for Random Lengths customers to access their
                            subscriptions and account information. In tandem, we designed tools for internal
                            administrators to manage the customers and customers' staff access to the Random Lengths
                            products.
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12}>
                        <img
                            src='/img/rl-story/portal-1.png'
                            width={'100%'}
                            alt='random-lengths-summary-graphic'
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <img
                            src='/img/rl-story/portal-2.png'
                            width={'100%'}
                            alt='random-lengths-summary-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    Branding = () => {
        return (
            <SpreadBody>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Branding New Brand Guide.'>
                            As a part of our process, Twenty Ideas developed a shiny new Digital Brand Interface
                            Guidelines for Random Lengths, marrying their original brand with modern web application
                            user-interface design
                        </MainBlurb>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-1.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-2.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-3.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-4.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-5.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/rl-story/branding-6.png'
                            width={'100%'}
                            alt='branding-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    OtherStories = () => {
        return (
            <SpreadBody>
                <Typography type='display1' style={{margin: '20px 0px', fontWeight: 500}}>
                    See our other partner stories
                </Typography>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/xprize-link-photo-gold.png'
                            color='#36426a'
                            height={300}
                            onClick={() => this.props.router.push('/xprize')}
                        >
                            <ProjectSelectorTitle title='XPRIZE' sub='$7m Adult Literacy'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/avant-link-photo-blue.png'
                            color='#36426a'
                            height={300}
                            onClick={() => this.props.router.push('/avant')}
                        >
                            <ProjectSelectorTitle title='Avant Assessment' sub='Leader in Language Assessment'/>
                        </ProjectSelectorCard>
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    render() {
        const {XprizeTitleSpread, Strategy, AdminPortal, Branding, OtherStories} = this

        return (
            <div>
                <XprizeTitleSpread/>
                <Strategy/>
                <AdminPortal/>
                <Branding/>
                <OtherStories/>
                <Footer accent navigateTo={this.props.router.push}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/RandomLengthsStory.tsx